// extracted by mini-css-extract-plugin
module.exports = {"certifications":"certifications___3bVvy","certifications__text":"certifications__text___1EVr4","certifications__logos__wrapper":"certifications__logos__wrapper___3Zpq-","certifications__logos":"certifications__logos___3M6Sa","google__agency":"google__agency___1k9Vq","certifications__logos__item":"certifications__logos__item___3owxd"};
    if(module.hot) {
      // 1677682836139
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  